export default "__VITE_ASSET__162a0454__"